<template>
  <v-card color="transparent" flat light>
    <v-card-text class="py-0">
      <v-container py-0>
        <v-layout row wrap>
          <v-flex xs12 md6 px-2>
            <translation-field
              ref="name"
              v-model="localTournament.name"
              :label="$t('fields.global.name')"
            />
          </v-flex>
          <v-flex xs12 md6 px-2>
            <translation-field
              v-model="localTournament.description"
              :label="$t('titles.roles.description')"
              :required="false"
            />
          </v-flex>
          <v-flex xs12 px-2>
            <stadium-field
              v-model="localTournament.stadiumId"
              :label="
                $t('action.actions.select', { field: $tc('models.stadium', 2) })
              "
              multiple
            />
          </v-flex>
          <v-flex md3 xs12 px-2>
            <v-text-field
              v-model="localTournament.numberParticipants"
              v-validate="'required'"
              type="number"
              :label="
                $t('fields.tournaments.numberParticipants', {
                  field: $t('titles.tournaments.participants'),
                })
              "
              min="1"
              max="100"
              step="1"
              :data-vv-name="
                $t('fields.tournaments.numberParticipants', {
                  field: $t('titles.tournaments.participants'),
                })
              "
              :error-messages="
                errors.collect(
                  $t('fields.tournaments.numberParticipants', {
                    field: $t('titles.tournaments.participants'),
                  })
                )
              "
              autocomplete="new-text"
              browser-autocomplete
            />
          </v-flex>
          <v-flex md3 xs12 px-2>
            <v-text-field
              v-model="localTournament.matchesDuration"
              v-validate="'required'"
              type="number"
              :label="
                $t('fields.tournaments.matchesDuration', {
                  field: $tc('models.team'),
                })
              "
              min="1"
              max="100"
              step="1"
              :data-vv-name="$tc('fields.tournaments.matchesDuration')"
              :error-messages="
                errors.collect($tc('fields.tournaments.matchesDuration'))
              "
            />
          </v-flex>
          <v-flex md3 xs12 px-2>
            <date-picker
              v-model="localTournament.startAt"
              v-validate="'required'"
              :label="$t('fields.tournaments.startAt')"
              :data-vv-name="$tc('fields.tournaments.startAt')"
              :error-messages="
                errors.collect($tc('fields.tournaments.startAt'))
              "
            />
          </v-flex>
          <v-flex md3 xs12 px-2>
            <date-picker
              v-model="localTournament.endAt"
              v-validate="'required'"
              :label="$t('fields.tournaments.endAt')"
              :data-vv-name="$tc('fields.tournaments.endAt')"
              :error-messages="errors.collect($tc('fields.tournaments.endAt'))"
            />
          </v-flex>
          <v-flex md3 sm6 xs12>
            <v-radio-group
              v-model="localTournament.type"
              v-validate="'required'"
              :label="$t('fields.global.type')"
              :data-vv-name="$tc('fields.global.type')"
              :error-messages="errors.collect($tc('fields.global.type'))"
              row
            >
              <v-radio
                :label="$tc('models.team', 2)"
                value="teams"
                color="primary"
              />
              <!-- <v-radio :label="$tc('models.user', 2)" value="users" color="primary"></v-radio> -->
            </v-radio-group>
          </v-flex>

          <v-flex md2 sm4 xs8 px-2>
            <v-switch
              v-model="localTournament.showRanking"
              v-validate="'required'"
              :label="$t('fields.tournaments.showRanking')"
              color="primary"
              :data-vv-name="$tc('fields.tournaments.showRanking')"
              :error-messages="
                errors.collect($tc('fields.tournaments.showRanking'))
              "
            />
          </v-flex>
          <v-flex md3 sm4 xs12 px-2>
            <v-switch
              v-model="localTournament.openInscription"
              v-validate="'required'"
              :label="$t('fields.tournaments.openInscription')"
              color="primary"
              :data-vv-name="$tc('fields.tournaments.openInscription')"
              :error-messages="
                errors.collect($tc('fields.tournaments.openInscription'))
              "
            />
          </v-flex>
          <v-flex md2 xs4 px-2>
            <v-switch
              v-model="localTournament.payment"
              :label="$t('fields.tournaments.payment')"
              color="primary"
              @change="onChangePayment"
            />
          </v-flex>
          <v-flex md2 xs4 px-2>
            <v-currency-field
              v-if="localTournament.payment"
              v-model="localTournament.price"
              v-validate="localTournament.payment ? 'required|decimal' : ''"
              :label="$t('fields.typeSubscriptions.price') + ' *'"
              suffix="€"
              clearable
              :data-vv-name="$t('fields.typeSubscriptions.price')"
              :error-messages="
                errors.collect($t('fields.typeSubscriptions.price'))
              "
            />
          </v-flex>
          <v-flex xs12 px-2>
            <button-upload
              :label="$t('fields.users.image')"
              :image.sync="img"
              :title.sync="titleFileImg"
              @file="(file) => $emit('update:file', file)"
            />
          </v-flex>
          <v-flex md2 xs4 px-2>
            <v-switch
              v-model="localTournament.active"
              :label="$t('fields.global.active')"
              color="primary"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import DatePicker from '@/components/widgets/Input/DatePicker'
import StadiumField from '@/components/widgets/Input/StadiumField'
import TranslationField from '@/components/widgets/Input/TranslationField'
import VCurrencyField from '@/components/widgets/Input/VCurrencyField'
import ButtonUpload from '@/components/widgets/button/ButtonUpload'
import { formatDate } from '@/helpers'

export default {
  name: 'TabInformation',
  components: {
    TranslationField,
    ButtonUpload,
    StadiumField,
    DatePicker,
    VCurrencyField,
  },
  props: {
    tournament: {
      type: Object,
      required: true,
    },

    valid: {
      type: Boolean,
      required: false,
      default: true,
    },
    fileImg: { type: [File, String], default: '', required: false },
  },
  data() {
    return {
      file: '',
      titleFileImg: '',
      img: '',
      menu_start: false,
      menu_end: false,
    }
  },
  computed: {
    localTournament: {
      get() {
        return this.tournament
      },
      set(value) {
        this.$emit('update:tournament', value)
      },
    },

    startAt() {
      if (!this.localTournament.startAt) {
        return ''
      }
      return formatDate(this.localTournament.startAt)
    },
    endAt() {
      if (!this.localTournament.endAt) {
        return ''
      }
      return formatDate(this.localTournament.endAt)
    },
  },
  watch: {
    'tournament.img': {
      handler: function (val /* , oldVal */) {
        if (val) {
          if (val.includes('http')) this.img = val
          else this.img = this.defaultValues.imageUrl + val
        } else {
          this.img = ''
        }

        this.titleFileImg = val
        this.$emit('update:fileImg', '')
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    clear() {
      this.$validator.reset()
      this.$refs.name.$validator.reset()
    },
    customValidate() {
      return Promise.all([this.validate(), this.$refs.name.validate()])
    },
    onChangePayment(payment) {
      if (!payment) this.localTournament.price = 0
    },
  },
}
</script>
